import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    if (password !== confirm) {
      return setMessage({ type: 'error', text: 'Passwörter stimmen nicht überein.' });
    }
    try {
      await axiosInstance.post('/auth/reset-password', { token, newPassword: password });
      setMessage({ type: 'success', text: 'Passwort erfolgreich zurückgesetzt.' });
      setTimeout(() => navigate('/login'), 3000);
    } catch {
      setMessage({ type: 'error', text: 'Fehler beim Zurücksetzen.' });
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-base-100 shadow-lg rounded">
      <h2 className="text-2xl font-bold mb-4">Neues Passwort setzen</h2>
      {message && (
        <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-error'} mb-4`}>
          {message.text}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <label className="label">Neues Passwort</label>
        <input
          type="password"
          className="input input-bordered w-full mb-4"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
        <label className="label">Wiederholen</label>
        <input
          type="password"
          className="input input-bordered w-full mb-4"
          value={confirm}
          onChange={e => setConfirm(e.target.value)}
          required
        />
        <button className="btn btn-primary w-full">Speichern</button>
      </form>
    </div>
  );
};

export default ResetPassword;
